import { ColorX } from "../../../../STATIC";

/**
 * @type {Object.<string, import("react").CSSProperties>}
 */
let styles = {
  container: {
    width: "auto",
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 0,
    paddingBottom: 0
  },
  inner: {
    borderRadius: 20,
    paddingTop: 0,
    paddingBottom: 0
  },
  manyFilterText: {
    fontWeight: "bold",
    textAlign: "center",
    color: ColorX.CSS("gambotBlue")
  },
  noFilterText: {
    width: "100%",
    fontWeight: "bold",
    textAlign: "center",
    color: ColorX.CSS("greyOut")
  },
  popbtntext: {
    flex: 1,
    textAlign: "center",
    color: ColorX.CSS("gambotBlue")
  },
  popbtnicon: {
    width: 20,
    height: 20
  },
  oneFilterLabel: {
    color: ColorX.CSS("skyBlue"),
    fontWeight: "bold",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "fit-content"
  },
  onefilter: {
    borderWidth: 1,
    borderColor: ColorX.CSS("skyBlue"),
    borderRadius: 15,
    borderStyle: "solid",
    backgroundColor: ColorX.BgCSS("skyBlue"),
    paddingLeft: 10,
    paddingRight: 10
  },
  operbtn: {
    padding: 0,
    paddingLeft: 5,
    paddingRight: 5,
    width: "fit-content"
  },
  operbtntext: {
    color: ColorX.CSS("skyBlue"),
    width: "fit-content",
    textOverflow: "ellipsis"
  },
  inputText: {
    borderWidth: 1,
    borderRadius: 5,
    borderColor: ColorX.CSS("skyBlue", 0.3),  
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 12,
    height: 20,
    flex: 1
  },
  valueselectbtn: {
    padding: 0,
    flex: 1
  },
  valueselecttext: {
    color: ColorX.CSS("lightBlue"),
    fontWeight: "bold",
    textAlign: "center"
  },
  valueselectnulltext: {
    color: ColorX.CSS("greyOut"),
    fontWeight: "bold",
    textAlign: "center"
  },
  rdperiodbtn: {
    padding: 0,
    flex: 1
  },  
  rdselectbtn: {
    padding: 0,
    flex: 1
  },
  advpopup: {
    width: "100%",
    maxHeight: 100
  },
  addfiltertextbtn: {
    color: ColorX.CSS("greyOut")
  },
  andortext: {
    fontWeight: "bold",
    textAlign: "center",
    color: ColorX.CSS("blue"),
    width: 40
  }
};

export default styles;